import { render, staticRenderFns } from "./EditOrderType.vue?vue&type=template&id=af2f576e&scoped=true"
import script from "./EditOrderType.vue?vue&type=script&lang=js"
export * from "./EditOrderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2f576e",
  null
  
)

export default component.exports